import { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Col, Alert, Button } from "antd";
import firebase from "firebase/app";
import * as EmailValidator from "email-validator";
import Logo from "../../assets/images/setpoint-logo.png";
import { ContentRow, FormCol, FormInput, FormButton } from "../../components/GlobalStyles";
import { getAppState } from "../../redux/selectors";
import { CHNAGE_LANGUAGE } from "../../redux/constants";

export function ForgetPassword(): ReactElement {
  const [email, setEmail] = useState<string>("");
  const [emailValidated, setEmailValidated] = useState<boolean>(true);
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { locale } = useSelector(getAppState);

  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const resetPassword = () => {
    const validated = EmailValidator.validate(email);
    setEmailValidated(validated);
    if (!validated) return;
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        setResult(true);
        setError(false);
        setErrorMsg("");
        console.log("Reset email sent");
      })
      .catch((e) => {
        setResult(false);
        setError(true);
        setErrorMsg(e.message);
      });
  };
  const goLogin = () => {
    history.push("/login");
  };

  const onChangeEmail = (value: string) => {
    setEmail(value);
    setResult(false);
    setError(false);
    setErrorMsg("");
  }

  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload: code
    })
    i18n.changeLanguage(code);
  }

  return (
    <ContentRow className="auth-container">
      <div className="landing-language-select-container">
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")}>{t("common.language")}</Button>
      </div>
      <Col style={{maxWidth: 360}}>
        <Card className="auth-form">
          <FormCol span="24">
            <img src={Logo} alt="Logo" style={{ width : 150, marginBottom: 30}} />
            <FormInput
              placeholder={t("auth.email")}
              value={email}
              onChange={(event) => onChangeEmail(event.target.value)}
              style={{ marginTop: "0px" }}
            />
            {!emailValidated && (
              <span className="error">{t("auth.invalidEmail")}</span>
            )}
            {result && (
              <Alert
                message={`Reset email has been sent to ${email}`}
                type="success"
                style={{ marginTop: "20px" }}
              />
            )}
            {error && (
              <Alert
              message={errorMsg}
              type="error"
              style={{ marginTop: "20px" }}
            />
            )}
          </FormCol>
          <FormButton type="primary" block onClick={resetPassword}>
            {t("auth.send_reset_password")}
          </FormButton>
          <FormButton type="primary" block onClick={goLogin}>
            {t("auth.go_to_login")}
          </FormButton>
        </Card>
      </Col>
      <div className="contact-us-container">
        <span>{t("menu.contact_us")}: </span>
        <a href="mailto:hi@setpointapp.com" target="_blank" rel="noreferrer">hi@setpointapp.com</a>
      </div>
    </ContentRow>
  );
}
